// extracted by mini-css-extract-plugin
export var wrapper = "d_b";
export var background = "d_v";
export var layer = "d_w";
export var column = "d_x";
export var moveDown = "d_y";
export var element = "d_r";
export var resultBg = "d_z";
export var moveRight = "d_B";
export var resultElement = "d_C";
export var calculation = "d_D";
export var content = "d_F";
export var heading = "d_G";
export var desc = "d_H";
export var action = "d_J";
export var calculator = "d_K";